"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialDatabaseEngine = void 0;
const viewer_data_engine_material_engine_1 = require("@shapediver/viewer.data-engine.material-engine");
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
class MaterialDatabaseEngine {
    constructor() {
        this._converter = viewer_shared_services_1.Converter.instance;
        this._httpClient = viewer_shared_services_1.HttpClient.instance;
        this._logger = viewer_shared_services_1.Logger.instance;
        this._materialDatabase = {};
        this._materialEngine = viewer_data_engine_material_engine_1.MaterialEngine.instance;
    }
    static get instance() {
        return this._instance || (this._instance = new this());
    }
    /**
     * Assigns materials from the material database to the geometry data in the given node.
     *
     * @param node the scene graph node
     */
    assignMaterialFromDatabase(node) {
        return __awaiter(this, void 0, void 0, function* () {
            if (Object.keys(this._materialDatabase).length === 0)
                return;
            // gather the materials that still need to be created
            // and the corresponding geometry data to assign the created material to
            const materialsToCreate = {};
            let updateNode = false;
            node.traverse((n) => {
                var _a;
                // check if the name of the material is corresponding to a material in the material database output
                for (let i = 0; i < n.data.length; i++) {
                    const data = n.data[i];
                    if (data instanceof viewer_shared_types_1.GeometryData) {
                        const name = (_a = data.material) === null || _a === void 0 ? void 0 : _a.name;
                        if (name) {
                            // if the material is not found directly, try with original node name as prefix
                            // this is can be used for instances
                            const materialName = this._materialDatabase[name]
                                ? name
                                : `${node.originalName}_${name}`;
                            if (this._materialDatabase[materialName]) {
                                if (!this._materialDatabase[materialName].material) {
                                    if (!materialsToCreate[materialName])
                                        materialsToCreate[materialName] = [];
                                    materialsToCreate[materialName].push(data);
                                }
                                else if (data.material !==
                                    this._materialDatabase[materialName].material) {
                                    data.material =
                                        this._materialDatabase[materialName]
                                            .material || null;
                                    // trigger an update of the geometry and the node
                                    data.updateVersion();
                                    updateNode = true;
                                }
                            }
                        }
                    }
                }
            });
            if (updateNode)
                node.updateVersion();
            // create the materials that are missing
            const materialNames = Object.keys(materialsToCreate);
            if (materialNames.length === 0)
                return;
            const promises = [];
            for (const materialName of materialNames) {
                promises.push(this._materialEngine.createMaterialDataFromDefinition(this._materialDatabase[materialName].definition));
            }
            // create the materials
            const materials = yield Promise.all(promises);
            updateNode = false;
            // assign the created materials to the corresponding geometry data
            for (let i = 0; i < materialNames.length; i++) {
                const material = materials[i];
                material.name = materialNames[i];
                this._materialDatabase[material.name].material = material;
                const geometryData = materialsToCreate[material.name];
                for (const data of geometryData) {
                    data.material = material;
                    data.updateVersion();
                    updateNode = true;
                }
            }
            if (updateNode)
                node.updateVersion();
        });
    }
    /**
     * Load the material database from the given output content.
     *
     * @param content the output content
     * @returns a scene graph node placeholder for the material database
     */
    loadContent(content) {
        return __awaiter(this, void 0, void 0, function* () {
            const materialDatabaseData = content.data;
            const materialDatabase = new viewer_shared_node_tree_1.TreeNode("materialDatabase");
            if (!materialDatabaseData)
                return materialDatabase;
            for (const key in materialDatabaseData) {
                if (this._materialDatabase[key]) {
                    if (JSON.stringify(this._materialDatabase[key].definition) !==
                        JSON.stringify(materialDatabaseData[key])) {
                        this._materialDatabase[key] = {
                            definition: materialDatabaseData[key],
                        };
                    }
                }
                else {
                    this._materialDatabase[key] = {
                        definition: materialDatabaseData[key],
                    };
                }
            }
            return materialDatabase;
        });
    }
}
exports.MaterialDatabaseEngine = MaterialDatabaseEngine;
//# sourceMappingURL=MaterialDatabaseEngine.js.map